import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BookOpen, Shield, Info, HelpCircle } from "lucide-react";

export default function Footer() {
  const loc = useLocation();
  // Hide footer on full-screen map pages and auth pages where it disrupts layout
  // /faq ships its own footer nav; the shared one would duplicate it.
  const hideOn = ["/home", "/trips", "/geofences", "/login", "/signup",
    "/link", "/onboarding", "/forgot-password", "/", "/faq"];
  if (hideOn.includes(loc.pathname) ||
      loc.pathname.startsWith("/headunit") ||
      loc.pathname.startsWith("/s/")) return null;

  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-8 px-4 mt-8 pb-32">
      <div className="max-w-2xl mx-auto flex flex-col sm:flex-row flex-wrap items-center justify-center gap-6 sm:gap-10">
        <Link to="/faq" className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors text-sm font-medium">
          <HelpCircle size={16} />
          <span>FAQ</span>
        </Link>
        <Link to="/user-manual" className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors text-sm font-medium">
          <BookOpen size={16} />
          <span>User Manual</span>
        </Link>
        <Link to="/privacy-policy" className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors text-sm font-medium">
          <Shield size={16} />
          <span>Privacy Policy</span>
        </Link>
        <Link to="/about-us" className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors text-sm font-medium">
          <Info size={16} />
          <span>About Us</span>
        </Link>
      </div>
      <div className="text-center mt-6 text-xs text-slate-600">
        CarTrack © {new Date().getFullYear()}
      </div>
    </footer>
  );
}
